/** Tab slugs for endpoint details — mirrored in the URL as `.../endpoints/:id/:tab`. */
export const ENDPOINT_DETAILS_TAB_VALUES = [
  'dashboard',
  'vulnerabilities',
  'malware-detection',
  'mitre-attck',
  'file-monitoring',
  'threat-hunting',
  'automated-response',
  'compliance',
  'technical-details',
] as const;

export type EndpointDetailsTab = (typeof ENDPOINT_DETAILS_TAB_VALUES)[number];

/** Labels match EDR sidebar leaf names where the tab shares that module. */
export const ENDPOINT_DETAILS_TAB_LABELS: Record<EndpointDetailsTab, string> = {
  dashboard: 'Dashboard',
  vulnerabilities: 'Vulnerability Detection',
  'malware-detection': 'Malware Detection',
  'mitre-attck': 'MITRE ATT&CK',
  'file-monitoring': 'File Integrity Monitoring',
  'threat-hunting': 'Threat Hunting',
  'automated-response': 'Automated Response',
  compliance: 'Configuration Compliance',
  'technical-details': 'Technical Details',
};

export const ENDPOINT_DETAILS_TABS: Array<{ label: string; value: EndpointDetailsTab }> =
  ENDPOINT_DETAILS_TAB_VALUES.map((value) => ({
    label: ENDPOINT_DETAILS_TAB_LABELS[value],
    value,
  }));

export const isEndpointDetailsTab = (value: string | undefined | null): value is EndpointDetailsTab =>
  Boolean(value && (ENDPOINT_DETAILS_TAB_VALUES as readonly string[]).includes(value));

export const DEFAULT_ENDPOINT_DETAILS_TAB: EndpointDetailsTab = 'dashboard';
